// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://static.rambler.ru/fonts/Roboto/Roboto.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://static.rambler.ru/fonts/Manrope/Manrope.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}
:root {
  font-size: 13px;
}
html,
body {
  height: 100%;
  -webkit-text-size-adjust: none !important;
     -moz-text-size-adjust: none !important;
          text-size-adjust: none !important;
}
body {
  margin: 0;
  margin: initial;
  padding: 0;
  padding: initial;
  min-width: 320px;
  min-height: 100%;
  background-color: #fff;
  background-color: var(--mainBackground);
  color: #262626;
  color: var(--mainForeground);
  font-size: 1rem;
  line-height: 1.54;
  font-family: Roboto, sans-serif;
  font-family: var(--fontFamily);
  font-weight: 400;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body * {
  font-family: inherit;
}
body div:last-of-type:not(#src-styles--root--Omd8v) * {
  box-sizing: border-box;
}
a:not(header + * + footer a),
[data-anchor] {
  color: #315efb;
  color: var(--primaryForeground);
  -webkit-text-decoration: none;
  text-decoration: none;
  outline: 0;
}
strong {
  font-weight: 500;
}
input[readonly] {
  caret-color: transparent;
}
@media screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2) {
input[type='email'],
input[type='number'],
input[type='password'],
input[type='search'],
input[type='tel'],
input[type='text'],
input[type='url'],
input[readonly] {
    font-size: 16px !important;
}

    input[type='email']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='email']::placeholder {
      font-size: 16px !important;
    }

    input[type='number']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='number']::placeholder {
      font-size: 16px !important;
    }

    input[type='password']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='password']::placeholder {
      font-size: 16px !important;
    }

    input[type='search']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='search']::placeholder {
      font-size: 16px !important;
    }

    input[type='tel']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='tel']::placeholder {
      font-size: 16px !important;
    }

    input[type='text']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='text']::placeholder {
      font-size: 16px !important;
    }

    input[type='url']::-moz-placeholder {
      font-size: 16px !important;
    }

    input[type='url']::placeholder {
      font-size: 16px !important;
    }

    input[readonly]::-moz-placeholder {
      font-size: 16px !important;
    }

    input[readonly]::placeholder {
      font-size: 16px !important;
    }
  }
#root > div {
  display: flex;
}
.grecaptcha-badge {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;AClBA;EACE,eAAe;AACjB;AAEA;;EAEE,YAAY;EACZ,yCAAiC;KAAjC,sCAAiC;UAAjC,iCAAiC;AACnC;AAEA;EACE,SAAe;EAAf,eAAe;EACf,UAAgB;EAAhB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAuC;EAAvC,uCAAuC;EACvC,cAA4B;EAA5B,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,+BAA8B;EAA9B,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,sBAAsB;AACxB;AAEA;;EAEE,cAA+B;EAA/B,+BAA+B;EAC/B,6BAAqB;EAArB,qBAAqB;EACrB,UAAU;AACZ;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,wBAAwB;AAC1B;AAUE;AARF;;;;;;;;IASI,0BAA0B;AAM9B;;IAJI;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;;IAFA;MACE,0BAA0B;IAC5B;EACF;AAGF;EACE,aAAa;AACf;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import url('https://static.rambler.ru/fonts/Roboto/Roboto.css');\n@import url('https://static.rambler.ru/fonts/Manrope/Manrope.css');\n@import 'utils/variables.css';\n\n:root {\n  font-size: 13px;\n}\n\nhtml,\nbody {\n  height: 100%;\n  text-size-adjust: none !important;\n}\n\nbody {\n  margin: initial;\n  padding: initial;\n  min-width: 320px;\n  min-height: 100%;\n  background-color: var(--mainBackground);\n  color: var(--mainForeground);\n  font-size: 1rem;\n  line-height: 1.54;\n  font-family: var(--fontFamily);\n  font-weight: 400;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody * {\n  font-family: inherit;\n}\n\nbody div:last-of-type:not(#root) * {\n  box-sizing: border-box;\n}\n\na:not(header + * + footer a),\n[data-anchor] {\n  color: var(--primaryForeground);\n  text-decoration: none;\n  outline: 0;\n}\n\nstrong {\n  font-weight: 500;\n}\n\ninput[readonly] {\n  caret-color: transparent;\n}\n\ninput[type='email'],\ninput[type='number'],\ninput[type='password'],\ninput[type='search'],\ninput[type='tel'],\ninput[type='text'],\ninput[type='url'],\ninput[readonly] {\n  @media (--iphone) {\n    font-size: 16px !important;\n\n    &::placeholder {\n      font-size: 16px !important;\n    }\n  }\n}\n\n:global(#root) > div {\n  display: flex;\n}\n\n:global(.grecaptcha-badge) {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-styles--root--Omd8v`
};
module.exports = ___CSS_LOADER_EXPORT___;
